/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ParametroModelDto } from '../../models/parametro-model-dto';

export interface ProgramasControllerListadoParametros$Params {
}

export function programasControllerListadoParametros(http: HttpClient, rootUrl: string, params?: ProgramasControllerListadoParametros$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ParametroModelDto>>> {
  const rb = new RequestBuilder(rootUrl, programasControllerListadoParametros.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ParametroModelDto>>;
    })
  );
}

programasControllerListadoParametros.PATH = '/api/programas/listado-parametros';
